import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Input, Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { create, prepare } from "../../api/Organization"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* The empty form of a new point */
const INITIAL = {

    name: "",
    phone: "",
    address: "",
    lat: "",
    lng: "",
    instagram: "",
    description: "",

    memberName: "",
    memberPhone: "",

    cityID: 0,
    categories: [],

    images: [],
    files: []
}


/* Widget Create Modal — a new point of the platform. It is opened by the reference:
   this._create.open() — the page of the creation is gone */
class CreateModal extends Component {

    constructor() {
        super()

        this.state = {

            visible: false,

            /* loading — the cities and the categories are being read, ok — the form is ready */
            status: "loading",
            data: null,

            waiting: false,

            ...INITIAL
        }
    }

    /* Open the form */
    open = () => {

        this.setState({ visible: true, status: "loading", waiting: false, ...INITIAL }, () => {

            prepare().then(response => {
                if (response && response.status === 200) {
                    this.setState({ status: "ok", data: response.data })
                }
                else {
                    this.setState({ status: "error" })
                }
            }).catch(() => this.setState({ status: "error" }))
        })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.waiting) {
            return
        }

        this.setState({ visible: false })
    }

    /* Add the category to the point or take it away */
    category = categoryID => {

        const { categories } = this.state
        const index = categories.findIndex(item => item === categoryID)

        if (index > -1) {
            categories.splice(index, 1)
        }
        else {
            categories.push(categoryID)
        }

        this.setState({ categories })
    }

    /* Choose the photos of the point — they are sent together with the form */
    upload = event => {

        const { images, files } = this.state

        for (const file of event.target.files) {
            files.push(file)
            images.push(URL.createObjectURL(file))
        }

        this.setState({ images, files })
    }

    /* Take one photo away */
    removeImage = index => {

        const { images, files } = this.state

        images.splice(index, 1)
        files.splice(index, 1)

        this.setState({ images, files })
    }

    /* Create the point */
    create = () => {

        /* Fields */
        const { name, phone, address, lat, lng, instagram, description, memberName, memberPhone, cityID, categories, files, waiting } = this.state
        const { onCreated } = this.props

        /* The request is already on its way */
        if (waiting) {
            return
        }

        if (name.trim().length === 0) {
            this._name.error("Введите название организации")
            return
        }

        if (phone.length !== 18) {
            this._phone.error("Введите телефон организации")
            return
        }

        if (address.trim().length === 0) {
            this._address.error("Введите адрес организации")
            return
        }

        if (lat.length === 0) {
            this._lat.error("Введите широту")
            return
        }

        if (lng.length === 0) {
            this._lng.error("Введите долготу")
            return
        }

        if (memberName.trim().length === 0) {
            this._memberName.error("Введите имя владельца")
            return
        }

        if (memberPhone.length !== 18) {
            this._memberPhone.error("Введите телефон владельца")
            return
        }

        if (cityID === 0) {
            toast.error("Выберите город")
            return
        }

        if (categories.length === 0) {
            toast.error("Выберите минимум одну категорию")
            return
        }

        const body = new FormData()

        body.append("name", name.trim())
        body.append("phone", phone)
        body.append("address", address.trim())
        body.append("lat", lat)
        body.append("lng", lng)
        body.append("instagram", instagram)
        body.append("description", description)
        body.append("memberName", memberName.trim())
        body.append("memberPhone", memberPhone)
        body.append("cityID", cityID)
        body.append("categories", JSON.stringify(categories))

        files.forEach(file => body.append("image", file))

        this.setState({ waiting: true })

        create(body).then(response => {

            if (response.status === 200) {
                this.setState({ visible: false })
                onCreated()
                toast.success("Организация создана")
                return
            }

            /* The telephone of the owner already has an account */
            if (response.status === 401 && response.data && response.data.message === "existing") {
                this._memberPhone.error("Телефон уже есть в базе")
                return
            }

            toast.error("Что-то пошло не так! Попробуйте позднее.")
        }).catch(() => {
            toast.error("Что-то пошло не так! Попробуйте позднее.")
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* The body of the form */
    _body = () => {

        /* Fields */
        const { status, data, waiting } = this.state
        const { name, phone, address, lat, lng, instagram, description, memberName, memberPhone, cityID, categories, images } = this.state

        if (status === "loading") {
            return <div className="wide-modal-loading"><LoadingOutlined /></div>
        }

        if (status !== "ok" || !data) {
            return (
                <div className="wide-modal-loading">
                    <Icon name="alert" size={38} width={1.5} />
                    <p>Не удалось загрузить справочники</p>
                </div>
            )
        }

        return (
            <div className="wide-modal-body">

                <div className="wide-modal-label">Об организации</div>

                <div className="organization-details-inputs">
                    <Input ref={ref => this._name = ref} label="Название организации" value={name} onChange={event => this.setState({ name: event.target.value })} />
                    <Input mask="+7 (999) 999-99-99" ref={ref => this._phone = ref} label="Телефон организации" value={phone} onChange={event => this.setState({ phone: event.target.value })} />
                </div>

                <Input ref={ref => this._address = ref} label="Адрес" value={address} onChange={event => this.setState({ address: event.target.value })} />

                <div className="organization-details-inputs">
                    <Input ref={ref => this._lat = ref} label="Широта (lat)" value={lat} onChange={event => this.setState({ lat: event.target.value })} />
                    <Input ref={ref => this._lng = ref} label="Долгота (lng)" value={lng} onChange={event => this.setState({ lng: event.target.value })} />
                </div>

                <div className="wide-modal-label">Владелец</div>
                <div className="wide-modal-hint">На этот телефон заводится аккаунт Bookify Pro — он станет владельцем точки.</div>

                <div className="organization-details-inputs">
                    <Input ref={ref => this._memberName = ref} label="Имя" value={memberName} onChange={event => this.setState({ memberName: event.target.value })} />
                    <Input mask="+7 (999) 999-99-99" ref={ref => this._memberPhone = ref} label="Телефон" value={memberPhone} onChange={event => this.setState({ memberPhone: event.target.value })} />
                </div>

                <div className="wide-modal-label">Город</div>

                <div className="organization-details-chips">
                    {data.cities.map(city =>
                        <div
                            key={`${city.id}`}
                            onClick={() => this.setState({ cityID: parseInt(city.id) })}
                            className={`organization-details-chip select ${parseInt(cityID) === parseInt(city.id) ? "active" : ""}`}
                        >
                            {city.name}
                        </div>
                    )}
                </div>

                <div className="wide-modal-label">Категории</div>

                <div className="organization-details-chips">
                    {data.categories.map(category =>
                        <div
                            key={`${category.id}`}
                            onClick={() => this.category(parseInt(category.id))}
                            className={`organization-details-chip select ${categories.indexOf(parseInt(category.id)) > -1 ? "active" : ""}`}
                        >
                            {category.name}
                        </div>
                    )}
                </div>

                <div className="wide-modal-label">Фотографии</div>
                <div className="wide-modal-hint">Первая станет главной. Можно добавить позже в карточке точки.</div>

                <div className="organization-details-images">

                    {images.map((image, index) =>
                        <div className="organization-details-image editable" key={`${index}`}>
                            <img src={image} alt="Organization" />
                            {index === 0 && <div className="organization-details-image-main">Главная</div>}
                            <div onClick={() => this.removeImage(index)} className="organization-details-image-remove">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        </div>
                    )}

                    <label className="organization-details-image upload">
                        <input onChange={event => this.upload(event)} multiple={true} type="file" name="file" accept="image/png, image/jpeg" />
                        <Icon name="image" size={20} />
                        <span>Добавить</span>
                    </label>

                </div>

                <div className="wide-modal-label">Дополнительно</div>

                <Input ref={ref => this._instagram = ref} label="Инстаграм" value={instagram} onChange={event => this.setState({ instagram: event.target.value })} />
                <Input textarea maxLength={600} hint="Клиент видит его в карточке заведения" ref={ref => this._description = ref} label="Описание" value={description} onChange={event => this.setState({ description: event.target.value })} />

                <div onClick={() => this.create()} className={`organization-details-button ${waiting ? "disabled" : ""}`}>
                    {waiting ? <LoadingOutlined /> : "Создать организацию"}
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal large"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>Новая организация</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {this._body()}

            </Modal>
        )
    }
}

export default CreateModal
